import { Box, BoxProps } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { GuardedLink } from "../GuardedLink";

export const BackButton = styled(GuardedLink)<
  BoxProps
  & {$isMobile?: boolean}
>(({ $isMobile }) => ({
  fontSize: ($isMobile ? "0.75rem" : "1.125rem"),
  fontWeight: 400,
  lineHeight: $isMobile ? (11 / 6) : (11 / 9),
  minWidth: $isMobile ? "auto" : "128px",
  padding: $isMobile ? "16px 0 0 0" : undefined
}));

export const AdminBoxContainer = styled(Box)<
  BoxProps
>(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px"
}));

export const LearnerBoxesContainer = styled(Box)<
  BoxProps
>(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginTop: "30px"
}));

export const LearnerBoxesList = styled(Box)<
  BoxProps
>(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px"
}));

export const DomainBox = styled(Box)<
  BoxProps
  & {$isActive?: boolean}
>(({
  theme,
  $isActive
}) => ({
  borderRadius: theme.spacing(1),
  boxShadow: $isActive ? `inset 0 0 0 2px ${theme.customColors.borderTag}` : `inset 0 0 0 1px ${alpha(theme.customColors.borderTag, 0.3)}`,
  cursor: "pointer",
  paddingLeft: "10px",
  paddingRight: "10px",
  transition: "box-shadow 0.2s ease-in-out",
  "&:hover": {
    boxShadow: `inset 0 0 0 2px ${theme.customColors.borderTag}`
  }
}));
